export default [
    {
        component: () => import(/* webpackChunkName: 'imunizacao-fila-atendimento' */ '@/views/imunizacao/fila-atendimento/Index'),
        path: 'fila-atendimento',
        redirect: 'fila-atendimento/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'imunizacao-fila-atendimento' */'@/views/imunizacao/fila-atendimento/List.vue'),
                name: 'imunizacao-fila-atendimento-index',
                path: 'index',
            },
        ],
    },
]